<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .time-box-1 span.none-sty{
        background: none;
        padding: 0;
        margin: 0;
        color: #fff;

    }
    .time-box-1 span{
        background: #b2aaff;
        margin:0 2px;
        display: inline-block;
        padding: 4px 2px;
        line-height: 14px;
        color: #fff;
    }
</style>
<template>
    <p class="time-box-1">
        <span>{{hour>9?parseInt(hour/10):0}}</span><span>{{hour%10}}</span>
        <span class="none-sty">:</span>
        <span>{{minute>9?parseInt(minute/10):0}}</span><span>{{minute%10}}</span>
        <span class="none-sty">:</span>
        <span>{{second>9?parseInt(second/10):0}}</span><span>{{second%10}}</span>
    </p>
</template>
<script>
    export default {
        name: '',
        data() {
            return {
                hour:'88',
                minute:'88',
                second:'88',
                time:0
            }
        },
        props: ['times'],
        methods: {
            getTime: function(){
                let time = (this.times - this.time*1000)/1000
                this.day =
                this.hour = parseInt(time/3600)
                this.minute = parseInt((time%3600)/60)
                this.second = parseInt(time%60)
            }
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
                this.getTime()
                let _this = this
                let set = setInterval(function(){
                    if(_this.times/1000 - _this.time > 0){
                        _this.time = _this.time + 1
                        _this.getTime()
                    }else{
                        clearInterval(set)
                    }
                },1000)
            })
        },
        created() {
        }
    }
</script>


// WEBPACK FOOTER //
// timeLabel.vue?4206ed94